import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Flex from 'components/Flex'
export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`
export const ResultDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.GREY_T_20};
  margin: 5px 0;
`
export const FileInfoDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
  width: 70%;
`
export const FileTextSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_60};
`
export const ResultIconDiv = styled.div`
  text-align: center;
  margin-bottom: 10px;
`
export const ButtonDiv = styled.div`
  margin: 10px 0;
`
